import type { SVGProps } from "react";
export interface RulerIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function RulerIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: RulerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M4.043 12.866a1.126 1.126 0 0 1 1.591 0l1.838 1.838.078.086a1.125 1.125 0 0 1-1.583 1.582l-.085-.077-1.839-1.837a1.127 1.127 0 0 1 0-1.592m2.942-2.94a1.125 1.125 0 0 1 1.505-.078l.085.078 1.839 1.837a1.127 1.127 0 0 1-1.591 1.592l-1.838-1.838-.078-.087a1.124 1.124 0 0 1 .078-1.504m2.941-2.942a1.124 1.124 0 0 1 1.504-.077l.087.077 1.838 1.839a1.126 1.126 0 0 1-1.592 1.59L9.926 8.576l-.078-.085a1.125 1.125 0 0 1 .078-1.506Zm2.94-2.941c.44-.44 1.153-.44 1.592 0l1.837 1.838.078.085A1.125 1.125 0 0 1 14.79 7.55l-.087-.078-1.838-1.838a1.126 1.126 0 0 1 0-1.591Z"
      />
      <path
        fill={color}
        d="M15.357 1.575a3.126 3.126 0 0 1 4.182.215l2.672 2.672.213.238a3.125 3.125 0 0 1 0 3.944l-.213.238L8.882 22.21a3.125 3.125 0 0 1-4.42 0l-2.671-2.672a3.125 3.125 0 0 1 0-4.419L15.119 1.79zm2.59 1.806a.876.876 0 0 0-1.1-.113l-.137.113L3.382 16.71a.876.876 0 0 0 0 1.238l2.671 2.672a.876.876 0 0 0 1.238 0L20.62 7.29l.111-.137a.88.88 0 0 0 0-.964l-.111-.136-2.672-2.672Z"
      />
    </svg>
  );
}
